// wiswiz 752 (Philip orders 2380/2381, overflow on diverse material): value tables in the steps ("x | -5 -4 ... 5" over
// "k(x) | ..."), written as one \begin{array} of 12-14 columns, stay wider than a phone page even at the smallest math
// scale: the last columns are cut. A table of more than MAX_COLS columns becomes two tables under each other, each with
// the first (label) column, so every value stays on the page. Anything it cannot read safely (nested environments, a row
// with another number of cells, an escaped &) is left as it is.
const MAX_COLS = 9;

export function splitWideArrays(tex: string): string {
  return tex.replace(/\\begin\{array\}\{([^{}]*)\}([\s\S]*?)\\end\{array\}/g, (whole, spec: string, body: string) => {
    const kinds = spec.replace(/[^lcr]/g, "").split("");
    const n = kinds.length;
    if (n <= MAX_COLS || /\\begin\{|\\&|\\multicolumn/.test(body)) return whole;
    const rows = body
      .split(/\\\\(?:\[[^\]]*\])?/)
      .map((r) => {
        const hline = /^\s*\\hline/.test(r);
        return { hline, cells: r.replace(/^\s*\\hline\s*/, "").split("&").map((c) => c.trim()) };
      })
      .filter((r, i, all) => !(i === all.length - 1 && r.cells.length === 1 && r.cells[0] === "" && !r.hline));
    const trailingHline = rows.length > 0 && rows[rows.length - 1].cells.length === 1 && rows[rows.length - 1].cells[0] === "";
    const data = trailingHline ? rows.slice(0, -1) : rows;
    if (!data.length || data.some((r) => r.cells.length !== n)) return whole;
    const k = 1 + Math.ceil((n - 1) / 2);
    const part = (cols: number[]) => {
      const sp = `${kinds[cols[0]]}|${cols.slice(1).map((c) => kinds[c]).join("|")}`;
      const lines = data.map((r) => `${r.hline ? "\\hline " : ""}${cols.map((c) => r.cells[c]).join(" & ")}`).join(" \\\\ ");
      return `\\begin{array}{${sp}}${lines}${trailingHline ? " \\\\ \\hline" : ""}\\end{array}`;
    };
    const left = Array.from({ length: k }, (_, i) => i);
    const right = [0, ...Array.from({ length: n - k }, (_, i) => k + i)];
    return `\\begin{gathered}${part(left)} \\\\[10pt] ${part(right)}\\end{gathered}`;
  });
}
